import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { Controller, Control, FieldErrors, UseFormSetValue } from "react-hook-form";

interface BasedOnComponentProps {
    control: Control<any>;
    errors: FieldErrors<{
        filter: {
            property_id: string;
            base_on: string;
            start_date: string;
            end_date: string;
            room_type_id?: string;
        };
    }>;
    setValue: UseFormSetValue<any>;
}

const baseOnOptions = ["created_reservation", "stay_date"];

const BasedOnComponent: React.FC<BasedOnComponentProps> = ({ control, errors, setValue }) => {

    useEffect(() => {
        setValue("base_on", "created_reservation");
    }, []);

    return (
        <div>
            <Form.Label className="me-2">Report Based On:</Form.Label>
            <Controller
                name="base_on"
                control={control}
                rules={{ required: "Report Based On is required" }}
                render={({ field }) => (
                    <>
                        {baseOnOptions.map((option) => (
                            console.log('da', field.value),
                            <Form.Check
                                key={option}
                                className="mt-2"
                                type="radio"
                                label={option.replace(/_/g, " ")} // Format agar lebih terbaca
                                value={option}
                                checked={field.value === option}
                                onChange={() => setValue("base_on", option)}
                            />
                        ))}
                    </>
                )}
            />

            {errors.filter?.base_on && (
                <span className="text-danger">{errors.filter.base_on.message}</span>
            )}
        </div>
    );
};

export default BasedOnComponent;
